import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Avatar } from "@/components/Avatar";

export default function LegalGuide() {
  const { slug } = useParams();
  const [guide, setGuide] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/legal/guides/public/${slug}`)
      .then(({ data }) => setGuide(data))
      .catch(() => setError("That guide is not published."));
  }, [slug]);

  if (error) return <div data-testid="public-guide-error" className="p-10 text-center text-sm text-slate-500">{error}</div>;
  if (!guide) return <div className="p-10 text-center text-sm text-slate-500">Loading…</div>;

  return (
    <div data-testid="public-guide-page" className="mx-auto max-w-2xl p-5 sm:p-10">
      <p className="overline text-slate-500">Unity &amp; Utility · Legal guide · {guide.country}</p>
      <h1 className="mt-1 font-display text-3xl font-bold tracking-tight text-[#0F172A] sm:text-4xl" data-testid="public-guide-title">
        {guide.title}
      </h1>
      <p className="mt-2 text-sm text-slate-600">{guide.summary}</p>
      <p className="mt-1 flex items-center gap-2 text-xs text-slate-500">
        <Avatar imageId={guide.author_avatar_id} sig={guide.author_avatar_sig} name={guide.author_name} size="sm" testid="public-guide-avatar" className="h-6 w-6 text-[0.55rem]" />
        By {guide.firm || guide.author_name}
      </p>
      <div className="mt-6 whitespace-pre-line text-sm leading-relaxed text-slate-700" data-testid="public-guide-body">
        {guide.body}
      </div>
      <p className="mt-8 border border-border bg-slate-50 px-3 py-2 text-xs text-slate-500">
        General information, not legal advice for your situation. Raise a matter in Unity &amp; Utility to
        get advice from a verified advocate.
      </p>
      <Link to="/login" className="mt-4 inline-block text-sm font-semibold text-[#002FA7] hover:underline">
        Sign in to instruct an advocate
      </Link>
    </div>
  );
}
